import * as React from "react";
import {withRouter} from "react-router-dom";
import Link from "gatsby-link";
import navigateTo from "../utils/navigate_to";
import Popover, {PopoverAnimationVertical} from "material-ui/Popover";
import Divider from "material-ui/Divider";
import CircularProgress from "material-ui/CircularProgress";
import {Menu, MenuItem} from "material-ui/Menu";
import * as Media from "react-media";
import OnClient from "../components/OnClient";

import Logo from "./Logo";
import WithCurrentUser from "./WithCurrentUser";
import DocSearch from "./DocSearch";
import {Location} from "history";
import {cdnAuthedUrl} from "../common";
import {CSSProperties} from "react";
import {RouteComponentProps} from "react-router";

const DEFAULT_USER_AVATAR = require("../res/avatar_default.png");

interface UserAvatarProps {
	avatarURL: string;
	fullName: string;
	logout: () => void;
}

class UserAvatar extends React.Component<UserAvatarProps, any> {
	state = {
		isPopoverOpen: false,
	};

	private avatarImageEl: HTMLElement;

	handleRequestPopoverClose() {
		this.setState({isPopoverOpen: false});
	}

	handleRequestPopoverOpen() {
		this.setState({isPopoverOpen: true});
	}

	goToPageFromPopover(url: string) {
		this.handleRequestPopoverClose();
		navigateTo(url);
	}

	render() {
		return (
			<>
			<img
				ref={el => (this.avatarImageEl = el)}
				src={cdnAuthedUrl(this.props.avatarURL) || DEFAULT_USER_AVATAR}
				style={{
						width: 40,
						height: 40,
						clipPath: "circle(20px)",
						marginBottom: 0,
						cursor: "pointer",
						borderTopLeftRadius: 20,
						borderTopRightRadius: 20,
						borderBottomRightRadius: 20,
						borderBottomLeftRadius: 20,
					}}
				onClick={this.handleRequestPopoverOpen.bind(this)}
			/>

			<Popover
				open={this.state.isPopoverOpen}
				anchorEl={this.avatarImageEl}
				anchorOrigin={{
						horizontal: "middle",
						vertical: "bottom",
					}}
				targetOrigin={{
						horizontal: "middle",
						vertical: "top",
					}}
				onRequestClose={this.handleRequestPopoverClose.bind(this)}
				style={{
						marginTop: 7,
					}}
				animation={PopoverAnimationVertical}
			>
				<Menu style={{ width: 175 }}>
					<MenuItem primaryText={this.props.fullName} disabled={true}/>
					<MenuItem
						primaryText="Profile"
						onClick={this.goToPageFromPopover.bind(this, "/user")}
					/>
					<MenuItem
						primaryText="Identity Tokens"
						onClick={this.goToPageFromPopover.bind(this, "/user/tokens")}
					/>
					<MenuItem
						primaryText="Apps"
						onClick={this.goToPageFromPopover.bind(this, "/user/apps")}
					/>
					<MenuItem
						primaryText="Templates"
						onClick={this.goToPageFromPopover.bind(this, "/user/templates")}
					/>
					<MenuItem
						primaryText="Payment"
						onClick={this.goToPageFromPopover.bind(this, "/user/wallet")}
					/>
					<Divider />
					<MenuItem primaryText="Logout" onClick={this.props.logout}/>
				</Menu>
			</Popover>
			</>
		);
	}
}

interface UserInfoProps {
	user: any;
	userFetchStatus: string;

	logout: () => void;
}

/**
 * displays the user's basic info in the top corner of the header
 */
const UserInfo = (props: UserInfoProps) => {
	if (props.userFetchStatus === "pending") {
		return <CircularProgress />;
	}

	if (props.user && !props.user.isActive) {
		//props.logout();
	}

	if (props.user === undefined || !props.user.isActive) {
		return (
			<>
			<Link
				to="/login"
				style={{
						marginLeft: "1.161em",
						marginRight: "1.161em",
						fontFamily: "Rajdhani",
						color: "#636363",
						textTransform: "uppercase",
					}}
			>
				Login
			</Link>
			</>
		);
	}

	return (
		<UserAvatar
			avatarURL={props.user.avatarURL}
			fullName={`${props.user.firstName}  ${props.user.lastName}`}
			logout={props.logout}
		/>
	);
};

interface HeaderProps extends RouteComponentProps<{}> {
	locationPath: any;
}

/**
 * checks if a nav item is active based on a path prefix
 * @param prefix the path prefix (ie. "/docs/core")
 * @param location the router's current page location
 */
function isNavItemActive(prefix: string, location: Location): boolean {
	return location.pathname.indexOf(prefix) === 0;
}

interface NavItemProps {
	link: string;
	activePrefix: any;
	title: string;
	style?: CSSProperties;
	activeStyle?: CSSProperties;
}

/**
 * displays a link in the header
 */
const NavItem = (props: NavItemProps) => (
	<Link
		to={props.link}
		style={{
			marginLeft: "1.161em",
			marginRight: "1.161em",
			fontFamily: "Rajdhani",
			color: "#636363",
			textTransform: "uppercase",
			...props.style,
		}}
		isActive={(match, location) => isNavItemActive(props.activePrefix, location)}
		activeStyle={{
			color: "#1B1B30",
			...props.activeStyle,
		}}
	>
		{props.title}
	</Link>
);

/**
 * top of page header
 */
class Header extends React.Component<HeaderProps, any> {
	state = {
		isSearchOpen: false,
		isPopoverOpen: false,
	};

	private labelElem: HTMLElement;

	handleRequestPopoverClose = () => {
		this.setState({isPopoverOpen: false});
	};

	handleRequestPopoverOpen = () => {
		this.setState({isPopoverOpen: true});
	};

	goToPageFromPopover = (url: string) => {
		this.handleRequestPopoverClose();
		navigateTo(url);
	};

	render() {
		const {isSearchOpen} = this.state;

		return (
			<Media query={{ maxWidth: 768 }}>
				{isMobile => (
					<OnClient>
						{hasRendered => (
							<>
							{hasRendered && (
								<div
									style={{
											display: "flex",
											flexDirection: "column",
											position: "fixed",
											top: 0,
											left: 0,
											right: 0,
											height: isMobile ? "6rem" : "5rem",
											zIndex: isSearchOpen ? 3 : 2, // cover up the hamburger menu when the search is open
											width: "100%",
										}}
								>
									<div
										style={{
												height: isMobile ? "calc(4rem - 6px)" : "5rem",
												padding: "1.61rem",
												display: "flex",
												flexDirection: "row",
												justifyContent: "space-between",
												backgroundColor: "white",
											}}
									>
										<Link to="/">
											<Logo
												isMobile={isMobile}
												style={{
														display: isSearchOpen && isMobile ? "none" : "block",
														height: isMobile ? "4.5rem" : "5.61rem",
														marginLeft: isMobile ? 0 : "10px",
														marginRight: isMobile ? 0 : "1.61rem",
														marginBottom: 0,
														marginTop: "-1.9rem",
														cursor: "pointer",
														position: isMobile ? "absolute" : "relative",
														left: isMobile ? "calc(50% - 36px)" : 0,
													}}
											/>
										</Link>

										{!isSearchOpen && !isMobile && (
											<div
												style={{
															display: "flex",
															flexDirection: "row",
															flex: 1,
															alignItems: "center",
														}}
											>
												<NavItem
													link="/docs/core/vatom"
													activePrefix="/docs/core"
													title="Basics"
												/>

												<NavItem
													link="/docs/reference/v1/http/getting-started"
													activePrefix="/docs/reference"
													title="Reference"
												/>

												<NavItem
													link="/docs/tutorial/step-by-step-publishing-a-vatom"
													activePrefix="/docs/tutorial"
													title="Tutorials"
												/>

												{/*<NavItem link="/docs/faq" activePrefix="/docs/faq" title="FAQs"/>*/}

												<NavItem link="/support" activePrefix="/support" title="Support"/>

												<NavItem link="/updates" activePrefix="/updates" title="Updates" />
											</div>
										)}

										<div
											style={{
													display: "flex",
													flex: 1,
													flexDirection: "row",
													alignItems: "center",
													width: isSearchOpen ? "100%" : "auto",
												}}
										>
											<DocSearch
												style={{
														fontSize: 20,
														padding: 5,
														boxSizing: "border-box",
														flex: 1,
														backgroundColor: "white",
														display:
															process.env.FEATURE_SEARCH_ENABLED === "true" ? "flex" : "none",
														justifyContent: "flex-end",
														alignItems: "center",
													}}
												textFieldStyle={
														isSearchOpen
															? {
																	lineHeight: "1rem",
																	height: 35,
																	flex: 1,
																	marginBottom: -8,
															  }
															: {
																	lineHeight: "1rem",
																	height: 35,
																	width: "100%",
																	marginBottom: -8,
															  }
													}
												onFocus={() => {
														this.setState({ isSearchOpen: true });
													}}
												onBlur={() => {
														this.setState({ isSearchOpen: false });
													}}
												isInFocus={isSearchOpen}
											/>
										</div>
										{ (
											<div
												style={{
														display: "flex",
														flexDirection: "row",
														alignItems: "center",
														textAlign: "right",
														marginLeft: "1rem",
													}}
											>

												{!isSearchOpen &&
												process.env.FEATURE_USER_ENABLED === "true" && (
													<WithCurrentUser>
														{(currentUser, currentUserFetchStatus, logout) => (
															<UserInfo
																user={currentUser}
																userFetchStatus={currentUserFetchStatus}
																logout={logout}
															/>
														)}
													</WithCurrentUser>
												)}

											</div>
										)}
									</div>

									{isMobile && <MobileNavigator />}
								</div>
							)}
							</>
						)}
					</OnClient>
				)}
			</Media>
		);
	}
}

class MobileNavigator extends React.Component {
	private scrollElement: HTMLElement;

	componentDidMount() {
		// shift the scroller to the left slightly to cut off first link - makes it obvious its scrollable
		this.scrollElement.scrollLeft = 50;
	}

	render() {
		return (
			<div
				style={{
					backgroundColor: "rgb(123, 151, 163)",
					display: "flex",
					width: "100%",
					color: "white",
					height: "calc(2rem + 6px)",
					justifyContent: "center",
					alignItems: "center",
				}}
			>
				<div
					ref={el => (this.scrollElement = el)}
					style={{
						whiteSpace: "nowrap",
						overflow: "scroll",
					}}
				>
					<NavItem
						link="/docs/core/vatom"
						activePrefix="/docs/core"
						title="Basics"
						style={{
							color: "white",
						}}
						activeStyle={{
							color: "white",
						}}
					/>

					<NavItem
						link="/docs/reference/v1/http/getting-started"
						activePrefix="/docs/reference"
						title="Reference"
						style={{
							color: "white",
						}}
						activeStyle={{
							color: "white",
						}}
					/>

					<NavItem
						link="/docs/tutorial/step-by-step-publishing-a-vatom"
						activePrefix="/docs/tutorial"
						title="Tutorials"
						style={{
							color: "white",
						}}
						activeStyle={{
							color: "white",
						}}
					/>

					{/*<NavItem
						link="/docs/faq"
						activePrefix="/docs/faq"
						title="FAQs"
						style={{
							color: "white",
						}}
						activeStyle={{
							color: "white",
						}}
					/>*/}

					<NavItem
						link="/support"
						activePrefix="/support"
						title="Support"
						style={{
							color: "white",
						}}
						activeStyle={{
							color: "white",
						}}
					/>

					<NavItem
						link="/updates"
						activePrefix="/updates"
						title="Updates"
						style={{
 							color: "white",
 						}}
						activeStyle={{
 							color: "white",
 						}}
					/>

				</div>
			</div>
		);
	}
}

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/components/Header.tsx